import {
    HospitalFill, HouseHeartFill,
    PeopleFill, GearFill, Search,
    BookFill, FileTextFill,
    BarChartFill, List, CreditCard,
    PersonCircle, BoxArrowRight, CashCoin,
    Receipt, People, JournalBookmarkFill,
    Clipboard2PlusFill,
    ClipboardCheckFill,
    QrCodeScan,
    QrCode,
    Calendar,
    Archive,
    FolderFill,
    Award,
    ArrowRightCircle,
    ExclamationTriangle,
    Bell,
    ListCheck,
    CardText,
    FileEarmarkText,
    ChatDots,
    Phone,
    BusFront,
    Ticket,
    Cart3,
    LayersFill,
    TrophyFill,
    PersonPlus,
} from 'react-bootstrap-icons'
import logo from '../images/logo.png'
import { useAuth } from '../hooks/useAuth';
import { useSchool } from '../contexts/SchoolContext';
import { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";

function Sidebar({ isCollapsed, onToggle, isOpen, setIsOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { user, isAuthenticated, logout: authLogout, isLoading } = useAuth();
  const { schoolSettings, getLogoUrl } = useSchool();
  const { primaryColor, darkenColor, lightenColor, hexToRgba } = useTheme();


  // Debug pour le logo
  const getLogoSrc = () => {
    const logoUrl = getLogoUrl();
    // console.log("School logo path:", schoolSettings.school_logo);
    // console.log("Generated logo URL:", logoUrl);
    return logoUrl || logo;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Les données utilisateur sont directement disponibles via le hook useAuth

  // Navigation sections based on user role
  const getNavigationSections = () => {
    if (!user || !user.role) {
      return [];
    }

    const userRole = user.role;

    if (userRole === "admin") {
      return [
        {
          title: "Tableau de Bord",
          items: [
            { name: "Dashboard Admin", href: "/admin/dashboard", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Gestion Académique",
          items: [
            { name: "Années Scolaires", href: "/school-years", icon: <Calendar /> },
            { name: "Sections", href: "/sections", icon: <HospitalFill /> },
            { name: "Niveaux", href: "/levels", icon: <BookFill /> },
            {
              name: "Classes",
              href: "/school-classes",
              icon: <HouseHeartFill />,
            },
            {
              name: "Matières",
              href: "/subjects",
              icon: <JournalBookmarkFill />,
            },
            {
              name: "Groupes de Matières",
              href: "/admin/subject-groups",
              icon: <LayersFill />,
            },
            {
              name: "Configuration Série-Matières",
              href: "/series-subject-configuration",
              icon: <JournalBookmarkFill />,
            },
            { name: "Enseignants", href: "/teachers", icon: <PeopleFill /> },
            { name: "Départements", href: "/departments", icon: <HospitalFill /> },
            { name: "Affectations & Prof. Principaux", href: "/teacher-assignments", icon: <PeopleFill /> },
            {
              name: "Tranches Paiement",
              href: "/payment-tranches",
              icon: <CreditCard />,
            },
          ],
        },
        {
          title: "Configuration Notes & Évaluations",
          items: [
            { name: "Périodes Académiques", href: "/academic-periods", icon: <Calendar /> },
            { name: "Barèmes de Notation", href: "/grading-scales", icon: <Award /> },
            { name: "Trimestres & Séquences", href: "/admin/trimesters-sequences", icon: <Calendar /> },
            { name: "Bulletins Scolaires", href: "/admin/bulletins", icon: <CardText /> },
            { name: "Livret Scolaire", href: "/admin/livret-scolaire", icon: <BookFill /> },
            { name: "Procès-Verbaux (PV)", href: "/admin/pv", icon: <FileEarmarkText /> },
            { name: "Fiches de Report de Notes", href: "/admin/mark-sheets", icon: <FileEarmarkText /> },
            { name: "Suivi Saisie Notes", href: "/admin/grade-tracking", icon: <ListCheck /> },
            { name: "Tableau d'Honneur", href: "/admin/honor-roll", icon: <TrophyFill /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Réinscription Anciens", href: "/re-enrollment", icon: <PersonPlus /> },
            { name: "Etat Inscriptions", href: "/enrollment-stats", icon: <PeopleFill /> },
            { name: "Inventaire", href: "/inventory", icon: <Archive /> },
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
            { name: "Réductions", href: "/manual-discounts", icon: <CashCoin /> },
            { name: "Rechercher", href: "/search", icon: <Search /> },
            { name: "Statistiques", href: "/stats", icon: <BarChartFill /> },
            { name: "Statistiques par Cycle", href: "/admin/statistiques-cycle", icon: <LayersFill /> },
          ],
        },
        {
          title: "Transport Scolaire",
          items: [
            { name: "Configuration Bus", href: "/bus/settings", icon: <GearFill /> },
            { name: "Vendre Abonnements", href: "/bus/subscriptions", icon: <BusFront /> },
            { name: "Liste des Abonnés", href: "/bus/subscribers", icon: <People /> },
            { name: "Générer Tickets Journaliers", href: "/bus/ticket-generation", icon: <Ticket /> },
            { name: "Point de Vente Tickets", href: "/bus/ticket-sales", icon: <Cart3 /> },
            { name: "Rapport Quotidien Bus", href: "/bus/daily-report", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Communication Parents", href: "/admin/parent-notifications", icon: <ChatDots /> },
            { name: "SMS Parents", href: "/admin/sms", icon: <Phone /> },
          ],
        },
        {
          title: "Discipline",
          items: [
            { name: "Gestion de la Discipline", href: "/admin/student-discipline", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Administration",
          items: [
            { name: "Gestion des Besoins", href: "/needs-management", icon: <ClipboardCheckFill /> },
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            { name: 'Utilisateurs', href: '/user-management', icon: <People/> },
            { name: 'Surveillants Généraux', href: '/supervisor-assignments', icon: <PersonCircle/> },
            { name: "Générateur de Cartes", href: "/card-generator", icon: <QrCode /> },
            { name: "Badges Personnel PDF", href: "/bulk-staff-cards", icon: <CreditCard /> },
            { name: "Configuration Cartes Élèves", href: "/id-card-manager/settings", icon: <GearFill /> },
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
            { name: "Paramètres", href: "/settings", icon: <GearFill /> },
          ],
        },
      ];
    } else if (userRole === "secretaire") {
      return [
        {
          title: "Gestion Académique",
          items: [
            { name: "Étudiants", href: "/students", icon: <PeopleFill /> },
            { name: "Classes", href: "/class-comp", icon: <HouseHeartFill /> },
            { name: "Matières", href: "/subjects", icon: <JournalBookmarkFill /> },
            { name: "Groupes de Matières", href: "/admin/subject-groups", icon: <LayersFill /> },
            { name: "Configuration Série-Matières", href: "/series-subject-configuration", icon: <JournalBookmarkFill /> },
            { name: "Enseignants", href: "/teachers", icon: <PeopleFill /> },
            { name: "Affectations & Prof. Principaux", href: "/teacher-assignments", icon: <PeopleFill /> },
            { name: "Rechercher", href: "/search", icon: <Search /> },
          ],
        },
        {
          title: "Configuration Notes & Évaluations",
          items: [
            { name: "Périodes Académiques", href: "/academic-periods", icon: <Calendar /> },
            { name: "Barèmes de Notation", href: "/grading-scales", icon: <Award /> },
            { name: "Trimestres & Séquences", href: "/admin/trimesters-sequences", icon: <Calendar /> },
            { name: "Bulletins Scolaires", href: "/admin/bulletins", icon: <CardText /> },
            { name: "Livret Scolaire", href: "/admin/livret-scolaire", icon: <BookFill /> },
            { name: "Procès-Verbaux (PV)", href: "/admin/pv", icon: <FileEarmarkText /> },
            { name: "Fiches de Report de Notes", href: "/admin/mark-sheets", icon: <FileEarmarkText /> },
            { name: "Suivi Saisie Notes", href: "/admin/grade-tracking", icon: <ListCheck /> },
            { name: "Tableau d'Honneur", href: "/admin/honor-roll", icon: <TrophyFill /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Réinscription Anciens", href: "/re-enrollment", icon: <PersonPlus /> },
            { name: "Etat Inscriptions", href: "/enrollment-stats", icon: <PeopleFill /> },
            { name: "Inventaire", href: "/inventory", icon: <Archive /> },
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
          ],
        },
        {
          title: "Paiements",
          items: [
            {
              name: "Frais de Dossiers",
              href: "/payments/documentary-fees",
              icon: <FileTextFill />,
            },
            {
              name: "Réductions",
              href: "/manual-discounts",
              icon: <CashCoin />,
            },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Communication Parents", href: "/admin/parent-notifications", icon: <ChatDots /> },
            { name: "SMS Parents", href: "/admin/sms", icon: <Phone /> },
            { name: "Mes Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Rapports",
          items: [
            {
              name: "États des Paiements",
              href: "/payment-reports",
              icon: <Receipt />,
            },
            {
              name: "État des Recouvrements",
              href: "/reports/recovery-status",
              icon: <BarChartFill />,
            },
            {
              name: "Certificats de Scolarité",
              href: "/reports/school-certificates",
              icon: <Award />,
            },
            {
              name: "Fiche de Scolarité par Classe",
              href: "/reports/class-fees-sheet",
              icon: <FileTextFill />,
            },
            {
              name: "Rapports Détaillés",
              href: "/reports/detailed-collection",
              icon: <FileTextFill />,
            },
          ],
        },
        {
          title: "Compte",
          items: [
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            ...(userRole === "comptable_superieur" ? [
              { name: "Gestion des Besoins", href: "/needs-management", icon: <ClipboardCheckFill /> }
            ] : []),
            { name: "Profil", href: "/profile", icon: <PersonCircle /> }
          ],
        },
      ];
    } else if (userRole === "accountant" || userRole === "comptable" || userRole === "comptable_superieur") {
      return [
        {
          title: "Comptabilité",
          items: [
            { name: "Classes", href: "/class-comp", icon: <HouseHeartFill /> },
            ...(userRole === "comptable_superieur" ? [
              { name: "Réinscription Anciens", href: "/re-enrollment", icon: <PersonPlus /> },
              { name: "Etat Inscriptions", href: "/enrollment-stats", icon: <PeopleFill /> },
            ] : []),
            { name: "Statistiques", href: "/stats", icon: <BarChartFill /> },
            { name: "Rechercher", href: "/search", icon: <Search /> },
            { name: "Réductions", href: "/manual-discounts", icon: <CashCoin /> },
          ],
        },
        {
          title: "Pédagogie",
          items: [
            ...(userRole === "comptable_superieur" ? [
              { name: "Procès-Verbaux (PV)", href: "/admin/pv", icon: <FileEarmarkText /> },
            ] : []),
            { name: "Fiches de Report de Notes", href: "/admin/mark-sheets", icon: <FileEarmarkText /> },
            { name: "Suivi Saisie Notes", href: "/admin/grade-tracking", icon: <ListCheck /> },
          ],
        },
        {
          title: "Présences",
          items: [
            ...((userRole === "comptable_superieur" || userRole === "accountant" || userRole === "comptable") ? [
            { name: "Appel Manuel Classes", href: "/manual-attendance", icon: <ListCheck /> },
            { name: "Suivi Présences Élèves", href: "/student-attendance-tracking", icon: <ClipboardCheckFill /> },
            { name: "Rapports Présence Étudiants", href: "/attendance-reports", icon: <FileTextFill /> },
            { name: "Suivi Présences Personnel", href: "/staff-daily-attendance", icon: <PeopleFill /> },
            { name: "Rapport Présence Personnel", href: "/staff-attendance-report", icon: <BarChartFill /> },
            { name: "Rapport Vacataires", href: "/reports/vacataire-attendance", icon: <FileEarmarkText /> },
            ] : []),
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "D.E (Demandes d'Explication)", href: "/demandes-explication", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Générateur de Cartes", href: "/card-generator", icon: <QrCode /> },
            { name: "Inventaire", href: "/inventory", icon: <Archive /> },
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
          ],
        },
        {
          title: "Paiements",
          items: [
            {
              name: "États de Paiements",
              href: "/payment-reports",
              icon: <Receipt />,
            },
            {
              name: "Frais de Dossiers",
              href: "/payments/documentary-fees",
              icon: <FileTextFill />,
            },
            ...((userRole === "comptable_superieur" || userRole === "accountant" || userRole === "comptable") ? [
              {
                name: "Gestion des Paiements",
                href: "/payment-management",
                icon: <CashCoin />,
              }
            ] : []),
          ],
        },
        {
          title: "Transport Scolaire",
          items: [
            { name: "Configuration Bus", href: "/bus/settings", icon: <GearFill /> },
            { name: "Vendre Abonnements", href: "/bus/subscriptions", icon: <BusFront /> },
            { name: "Liste des Abonnés", href: "/bus/subscribers", icon: <People /> },
            { name: "Générer Tickets Journaliers", href: "/bus/ticket-generation", icon: <Ticket /> },
            { name: "Point de Vente Tickets", href: "/bus/ticket-sales", icon: <Cart3 /> },
            { name: "Rapport Quotidien Bus", href: "/bus/daily-report", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Rapports",
          items: [
            {
              name: "Rapports Financiers",
              href: "/reports",
              icon: <FileTextFill />,
            },
            {
              name: "Détail Paiements Scolarité",
              href: "/reports/school-fee-payment-details",
              icon: <Receipt />,
            },
            {
              name: "Encaissement Détaillé Période",
              href: "/reports/detailed-collection",
              icon: <CashCoin />,
            },
            {
              name: "Paiement Frais par Classe",
              href: "/reports/class-school-fees",
              icon: <Receipt />,
            },
            {
              name: "État de Recouvrement",
              href: "/reports/recovery-status",
              icon: <BarChartFill />,
            },
            {
              name: "Certificats de Scolarité",
              href: "/reports/school-certificates",
              icon: <Award />,
            },
            {
              name: "Fiche de Scolarité par Classe",
              href: "/reports/class-fees-sheet",
              icon: <FileTextFill />,
            },
            {
              name: "Arriérés (Insolvables)",
              href: "/arrears-management",
              icon: <ExclamationTriangle />,
            },
          ],
        },
        {
          title: "Compte",
          items: [
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            ...(userRole === "comptable_superieur" ? [
              { name: "Gestion des Besoins", href: "/needs-management", icon: <ClipboardCheckFill /> }
            ] : []),
            { name: "Profil", href: "/profile", icon: <PersonCircle /> }
          ],
        },
      ];
    } else if (userRole === "surveillant_general") {
      return [
        {
          title: "Présences",
          items: [
            { name: "Appel Manuel Classes", href: "/manual-attendance", icon: <ListCheck /> },
            { name: "Scanner QR Personnel", href: "/staff-attendance-scanner", icon: <QrCodeScan /> },
            { name: "Rapports Présence", href: "/attendance-reports", icon: <FileTextFill /> },
          ],
        },
        {
          title: "Discipline",
          items: [
            { name: "Gestion de la Discipline", href: "/admin/student-discipline", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Mes Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Profil",
          items: [
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
          ],
        },
      ];
    } else if (userRole === "surveillant_secteur") {
      return [
        {
          title: "Présences Personnel",
          items: [
            { name: "Scanner QR Personnel", href: "/staff-attendance-scanner", icon: <QrCodeScan /> },
            { name: "Rapports Personnel", href: "/staff-attendance-report", icon: <FileTextFill /> },
          ],
        },
        {
          title: "Présences Élèves",
          items: [
            { name: "Appel Manuel Classes", href: "/manual-attendance", icon: <ListCheck /> },
            { name: "Scanner QR Élèves", href: "/attendance", icon: <QrCodeScan /> },
            { name: "Rapports Élèves", href: "/attendance-reports", icon: <ClipboardCheckFill /> },
          ],
        },
        {
          title: "Gestion",
          items: [
            { name: "Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
            { name: "Gestion des Besoins", href: "/needs-management", icon: <ClipboardCheckFill /> },
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
          ],
        },
        {
          title: "Profil",
          items: [
            { name: "Mon Profil", href: "/profile", icon: <PersonCircle /> },
          ],
        },
      ];
    } else if (userRole === "principal") {
      return [
        {
          title: "Tableau de Bord",
          items: [
            { name: "Dashboard Admin", href: "/admin/dashboard", icon: <BarChartFill /> },
            { name: "Tableau de Bord", href: "/principal/dashboard", icon: <HouseHeartFill /> },
          ],
        },
        {
          title: "Gestion Académique",
          items: [
            { name: "Années Scolaires", href: "/school-years", icon: <Calendar /> },
            { name: "Sections", href: "/sections", icon: <HospitalFill /> },
            { name: "Niveaux", href: "/levels", icon: <BookFill /> },
            { name: "Classes", href: "/school-classes", icon: <HouseHeartFill /> },
            { name: "Matières", href: "/subjects", icon: <JournalBookmarkFill /> },
            { name: "Groupes de Matières", href: "/admin/subject-groups", icon: <LayersFill /> },
            { name: "Configuration Série-Matières", href: "/series-subject-configuration", icon: <JournalBookmarkFill /> },
            { name: "Enseignants", href: "/teachers", icon: <PeopleFill /> },
            { name: "Départements", href: "/departments", icon: <HospitalFill /> },
            { name: "Affectations & Prof. Principaux", href: "/teacher-assignments", icon: <PeopleFill /> },
          ],
        },
        {
          title: "Configuration Notes & Évaluations",
          items: [
            { name: "Périodes Académiques", href: "/academic-periods", icon: <Calendar /> },
            { name: "Barèmes de Notation", href: "/grading-scales", icon: <Award /> },
            { name: "Trimestres & Séquences", href: "/admin/trimesters-sequences", icon: <Calendar /> },
            { name: "Bulletins Scolaires", href: "/admin/bulletins", icon: <CardText /> },
            { name: "Livret Scolaire", href: "/admin/livret-scolaire", icon: <BookFill /> },
            { name: "Procès-Verbaux (PV)", href: "/admin/pv", icon: <FileEarmarkText /> },
            { name: "Fiches de Report de Notes", href: "/admin/mark-sheets", icon: <FileEarmarkText /> },
            { name: "Suivi Saisie Notes", href: "/admin/grade-tracking", icon: <ListCheck /> },
            { name: "Tableau d'Honneur", href: "/admin/honor-roll", icon: <TrophyFill /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Etat Inscriptions", href: "/enrollment-stats", icon: <PeopleFill /> },
            { name: "Inventaire", href: "/inventory", icon: <Archive /> },
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
            { name: "Rechercher", href: "/search", icon: <Search /> },
            { name: "Statistiques", href: "/stats", icon: <BarChartFill /> },
            { name: "Statistiques par Cycle", href: "/admin/statistiques-cycle", icon: <LayersFill /> },
          ],
        },
        {
          title: "Transport Scolaire",
          items: [
            { name: "Configuration Bus", href: "/bus/settings", icon: <GearFill /> },
            { name: "Vendre Abonnements", href: "/bus/subscriptions", icon: <BusFront /> },
            { name: "Liste des Abonnés", href: "/bus/subscribers", icon: <People /> },
            { name: "Générer Tickets Journaliers", href: "/bus/ticket-generation", icon: <Ticket /> },
            { name: "Point de Vente Tickets", href: "/bus/ticket-sales", icon: <Cart3 /> },
            { name: "Rapport Quotidien Bus", href: "/bus/daily-report", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Rapports",
          items: [
            { name: "Certificats de Scolarité", href: "/reports/school-certificates", icon: <Award /> },
            { name: "Fiche de Scolarité par Classe", href: "/reports/class-fees-sheet", icon: <FileTextFill /> },
            { name: "Arriérés (Insolvables)", href: "/arrears-management", icon: <ExclamationTriangle /> },
            { name: "Rapport Personnel", href: "/reports/staff-attendance-report", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Communication Parents", href: "/admin/parent-notifications", icon: <ChatDots /> },
            { name: "SMS Parents", href: "/admin/sms", icon: <Phone /> },
            { name: "Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
            { name: "Gestion des Besoins", href: "/needs-management", icon: <ClipboardCheckFill /> },
          ],
        },
        {
          title: "Discipline",
          items: [
            { name: "Gestion de la Discipline", href: "/admin/student-discipline", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Administration",
          items: [
            { name: "Utilisateurs", href: "/user-management", icon: <People /> },
            { name: "Surveillants Généraux", href: "/supervisor-assignments", icon: <PersonCircle /> },
            { name: "Générateur de Cartes", href: "/card-generator", icon: <QrCode /> },
            { name: "Badges Personnel PDF", href: "/bulk-staff-cards", icon: <CreditCard /> },
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            { name: "Paramètres", href: "/settings", icon: <GearFill /> },
          ],
        },
      ];
    } else if (userRole === "bibliothecaire") {
      return [
        {
          title: "Scan Personnel",
          items: [
            { name: "Scanner QR Personnel", href: "/staff-attendance-scanner", icon: <QrCodeScan /> },
            { name: "Présences du Jour", href: "/staff-daily-attendance", icon: <Calendar /> },
            { name: "Rapports Présence", href: "/staff-attendance-report", icon: <BarChartFill /> },
          ],
        },
        {
          title: "Scan Étudiants",
          items: [
            { name: "Appel Manuel Classes", href: "/manual-attendance", icon: <ListCheck /> },
            { name: "Scanner QR Étudiants", href: "/attendance", icon: <QrCodeScan /> },
            { name: "Rapports Présence Étudiants", href: "/attendance-reports", icon: <FileTextFill /> },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Mes Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
          ],
        },
        {
          title: "Compte",
          items: [
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
          ],
        },
      ];
    } else if (userRole === "teacher") {
      return [
        {
          title: "Mon Espace Enseignant",
          items: [
            {
              name: "Mon Dashboard",
              href: "/teacher/dashboard",
              icon: <HouseHeartFill />,
            },
          ],
        },
        {
          title: "Enseignement",
          items: [
            {
              name: "Mes Classes",
              href: "/teacher/dashboard",
              icon: <PeopleFill />,
            },
            {
              name: "Compétences Évaluées",
              href: "/teacher/competences",
              icon: <JournalBookmarkFill />,
            },
          ],
        },
        {
          title: "Examens",
          items: [
            { name: "Trimestres", href: "/trimesters", icon: <BookFill /> },
          ],
        },
        {
          title: "Communication",
          items: [
            { name: "Mes Demandes d'Explication", href: "/mes-demandes-explication", icon: <ExclamationTriangle /> },
          ],
        },
        {
          title: "Outils",
          items: [
            { name: "Documents", href: "/documents", icon: <FolderFill /> },
            { name: "Mes Besoins", href: "/my-needs", icon: <Clipboard2PlusFill /> },
            { name: "Rechercher", href: "/search", icon: <Search /> },
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
          ],
        },
      ];
    } else if (userRole === "id_card_manager") {
      return [
        {
          title: "Gestion des Cartes d'Identité",
          items: [
            {
              name: "Tableau de Bord",
              href: "/id-card-manager/dashboard",
              icon: <HouseHeartFill />,
            },
            {
              name: "Classes",
              href: "/school-classes",
              icon: <HouseHeartFill />,
            },
          ],
        },
        {
          title: "Configuration",
          items: [
            {
              name: "Paramètres de Carte",
              href: "/id-card-manager/settings",
              icon: <GearFill />,
            },
          ],
        },
        {
          title: "Compte",
          items: [
            { name: "Profil", href: "/profile", icon: <PersonCircle /> },
          ],
        },
      ];
    }
  };

  const logout = async () => {
    try {
      await authLogout();
      navigate("/login");
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
      // Force logout même en cas d'erreur
      navigate("/login");
    }
  };

  const getUserDisplayName = () => {
    if (isLoading || !user) return "";

    if (user.role === "admin" || user.role === "accountant" || user.role === "comptable" || user.role === "comptable_superieur") {
      return user.username || user.name || "";
    } else {
      return user.name || "";
    }
  };

  const getUserRole = () => {
    if (isLoading || !user) return "";

    switch (user.role) {
      case "admin":
        return "Administrateur";
      case "accountant":
      case "comptable":
        return "Comptable";
      case "comptable_superieur":
        return "Comptable Supérieur";
      case "secretaire":
        return "Secretaire";
      case "teacher":
        return "Enseignant";
      case "surveillant_general":
        return "Surveillant Général";
      case "surveillant_secteur":
        return "Surveillant de Secteur";
      case "id_card_manager":
        return "Gestionnaire de Cartes";
      default:
        return "Utilisateur";
    }
  };

  const getUserInitials = () => {
    const name = getUserDisplayName();
    if (!name) return "U";

    const words = name.split(" ").filter((word) => word.length > 0);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  const handleLinkClick = (href) => {
    if (isMobile) {
      setIsOpen(false);
    }
  };

  if (!isAuthenticated || !user) {
    return null;
  }

  const navigationSections = (getNavigationSections() || []).filter(
    section => section.items && section.items.length > 0
  );

  // Render the sidebar with proper styling
  return (
    <>
      {/* Mobile overlay */}
      <div
        className="sidebar-overlay"
        onClick={() => setIsOpen(false)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 999,
          opacity: isMobile && isOpen ? 1 : 0,
          pointerEvents: isMobile && isOpen ? "auto" : "none",
          transition: "opacity 0.3s ease",
        }}
      />

      {/* Sidebar */}
      <div
        className={`sidebar ${isCollapsed ? "collapsed" : ""} ${
          isMobile && isOpen ? "mobile-open" : ""
        }`}
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          width: isCollapsed && !isMobile ? "80px" : "280px",
          height: "100vh",
          backgroundColor: darkenColor(primaryColor, 40),
          color: "white",
          zIndex: 1000,
          transition: "width 0.3s ease",
          transform:
            isMobile && !isOpen ? "translateX(-100%)" : "translateX(0)",
          boxShadow: `2px 0 10px ${hexToRgba(primaryColor, 0.2)}`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px",
            borderBottom: `1px solid ${hexToRgba(primaryColor, 0.3)}`,
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <img
            src={getLogoSrc()}
            alt={`${schoolSettings.school_name || "CPBD"} Logo`}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "contain",
            }}
            onError={(e) => {
              // En cas d'erreur de chargement, utiliser le logo par défaut
              e.target.src = logo;
            }}
          />
          {(!isCollapsed || isMobile) && (
            <div>
              <div style={{ fontSize: "18px", fontWeight: "bold", color: primaryColor }}>
                {schoolSettings.school_name
                  ?.split(" ")
                  .map((word) => word.charAt(0))
                  .join("") || "CPBD"}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: lightenColor(primaryColor, 30),
                }}
              >
                {schoolSettings.school_name ||
                  "College Polyvalent Bilingue de Douala"}
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <div style={{ flex: 1, padding: "20px 0", overflowY: "auto" }}>
          {navigationSections.map((section) => (
            <div key={section.title} style={{ marginBottom: "30px" }}>
              {(!isCollapsed || isMobile) && (
                <div
                  style={{
                    padding: "0 20px 10px",
                    fontSize: "12px",
                    color: lightenColor(primaryColor, 20),
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    fontWeight: "600",
                  }}
                >
                  {section.title}
                </div>
              )}
              {section.items.map((item) => {
                const isActive = location.pathname === item.href;
                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    className="sidebar-nav-link"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "12px 20px",
                      color: isActive ? primaryColor : "rgba(0,0,0,0.6)",
                      backgroundColor: isActive
                        ? hexToRgba(primaryColor, 0.2)
                        : "transparent",
                      textDecoration: "none",
                      transition: "all 0.2s ease",
                      borderLeft: isActive
                        ? `3px solid ${primaryColor}`
                        : "3px solid transparent",
                    }}
                    onClick={() => handleLinkClick(item.href)}
                  >
                    <div style={{ fontSize: "18px", minWidth: "18px" }}>
                      {item.icon}
                    </div>
                    {(!isCollapsed || isMobile) && (
                      <span style={{ fontSize: "14px", fontWeight: "500" }}>
                        {item.name}
                      </span>
                    )}
                  </Link>
                );
              })}
            </div>
          ))}
        </div>

        {/* User Profile */}
        <div
          style={{
            padding: "20px",
            borderTop: `1px solid ${hexToRgba(primaryColor, 0.3)}`,
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: primaryColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "16px",
              fontWeight: "bold",
              color: "white",
            }}
          >
            {getUserInitials()}
          </div>
          {(!isCollapsed || isMobile) && (
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: primaryColor }}>
                {getUserDisplayName()}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: lightenColor(primaryColor, 30),
                }}
              >
                {getUserRole()}
              </div>
            </div>
          )}
          <button
            onClick={logout}
            title="Se déconnecter"
            style={{
              background: "transparent",
              border: "none",
              color: lightenColor(primaryColor, 20),
              padding: "8px",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "16px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = hexToRgba(primaryColor, 0.2);
              e.target.style.color = "#f8fafc";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = lightenColor(primaryColor, 20);
            }}
          >
            <BoxArrowRight size={16} />
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;